import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { HcMedicalTestAttachmentContainerModel } from '../../../../../models/aggregates/healthcare/medical_test_attachment_container.model';

@Injectable({providedIn: 'root'})
export class HcMedicalTestAttachmentLoginEpService extends BaseApiTemplateService<HcMedicalTestAttachmentContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "patient-medical-test-attachments/" + Core2Config.LOGIN_EP_SUFFIX;
  readonly endpointPathGeneric = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HEALTHCARE_PREFIX + "patient-medical-test-attachments/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointPathGeneric + Core2Config.LOGIN_EP_SUFFIX;
    this.endpoint_path = this.endpointPathGeneric + Core2Config.LOGIN_EP_SUFFIX;
    this.httpClient = http;
  }
}